import React, { useEffect, useState, useCallback } from 'react';
import {
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import {
  Business as BusinessIcon,
  Devices as DevicesIcon,
  Thermostat as ThermostatIcon,
  Water as WaterIcon,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { hospitalsAPI, devicesAPI } from '../../services/api';
import { setHospitals } from '../../store/slices/hospitalSlice';
import { setDevices } from '../../store/slices/deviceSlice';
import { useAuth } from '../../contexts/AuthContext';

function StatCard({ title, value, icon, color = 'primary' }) {
  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center">
          <Box sx={{ color: `${color}.main`, mr: 2 }}>
            {icon}
          </Box>
          <Box>
            <Typography color="textSecondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4">
              {value}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

function Dashboard() {
  const dispatch = useDispatch();
  const { hospitals } = useSelector((state) => state.hospitals);
  const { isSuperAdmin } = useAuth();
  const [stats, setStats] = useState({
    avgTemperature: 0,
    avgHumidity: 0,
    activeDevices: 0,
  });

  const loadData = useCallback(async () => {
    try {
      const [hospitalsRes, devicesRes, statsRes] = await Promise.all([
        hospitalsAPI.getAll(),
        devicesAPI.getAll(),
        devicesAPI.getStats(),
      ]);
      
      dispatch(setHospitals(hospitalsRes.data));
      dispatch(setDevices(devicesRes.data));
      setStats(statsRes.data);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    }
  }, [dispatch]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      
      <Grid container spacing={3}>
        {isSuperAdmin && (
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Hospitais"
              value={hospitals.length}
              icon={<BusinessIcon />}
              color="primary"
            />
          </Grid>
        )}
        
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Dispositivos Ativos"
            value={stats.activeDevices || 0}
            icon={<DevicesIcon />}
            color="success"
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Temperatura Média"
            value={stats.avgTemperature ? `${stats.avgTemperature}°C` : 'N/A'}
            icon={<ThermostatIcon />}
            color="warning"
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Umidade Média"
            value={stats.avgHumidity ? `${stats.avgHumidity}%` : 'N/A'}
            icon={<WaterIcon />}
            color="info"
          />
        </Grid>
        
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Status do Sistema
            </Typography>
            <Typography variant="body1" color="success.main">
              ✅ Sistema operacional
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Todos os serviços estão funcionando normalmente
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard;